import React, { useEffect } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import { useSchool } from '../../DataStore/SchoolContext';
import Pagination from '../../components/Common/Pagination';
import AlertNotification from '../../components/Common/AlertNotification';
import { useSchoolTransactions } from '../../DataStore/FeesTransactionContext';
import TransactionList from '../../components/SchoolFees/TransactionList';
import AlertDeleteLedger from '../../components/Ledger/AlertDeleteLedger';

const FeesTransactionsPage = () => {

    const {notify, getClasses, setNotify} = useSchool();
    const {getTransactions, showDelete, toggleDelete, setCurrentPage, metaData, selectedIds} = useSchoolTransactions();
    

    useEffect(()=>{
        getClasses();
        getTransactions();
    }, [])

   

    const handleDelete = () =>{
        if(selectedIds.length === 0){
            setNotify(<AlertNotification type="info" message="No transaction was selected. Please make selection then try again." closable={false} iconClass="fa fa-info-circle"/>);
            return;
        }
        toggleDelete(true)
    }

    const PageActions = ()=>(<>
        <ActionDropdownItem iconClass="fa fa-refresh text-success" label="Refresh" onClick={()=>getTransactions(true)}/>
        <ActionDropdownItem iconClass="fa fa-trash-can" label="Delete Selection" onClick={handleDelete} className="text-danger"/>
        </>)


    return (
        <>
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="School Fees Transactions"
                    description="View all billing. discount, and payment transactions for school fees."
                    iconClass="fa fa-handshake"
                    PageActions={PageActions}
                    sticky={true}
                    Pagination={metaData ? <Pagination
                        metaData={metaData}
                        onPageChange={(page) => setCurrentPage(page)}
                        loadMore={false}
                /> : <></>}
                />
                {notify}
                
                <TransactionList />
               
                
            </MainContent>
        </PageContainer>
        {selectedIds.length > 0 && 
            <AlertDeleteLedger
            title="Delete Transactions"
            alertDescription={`Please confirm that you want to delete the selected fees transaction${
              selectedIds.length === 1 ? "" : "s"
            }. Found ${selectedIds.length} record${selectedIds.length === 1 ? "" : "s"} selected.`}
            show={showDelete}
            handleClose={() => toggleDelete(false)}
            selection={selectedIds}
          />
          }
        </>
    );
};

export default FeesTransactionsPage;
